import React from "react"
import autobind from "class-autobind"
import { Paper, FontIcon, Toggle } from "material-ui"
import { green500, red500 } from "material-ui/styles/colors"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import ScheduleTimeinfoAddBudgetDialog from "./ScheduleTimeinfoAddBudgetDialog"
import * as api from "../../../../api"
import { IBudgetUnitItem, IPosition, IScheduleShift, IScheduleBudgetDay, IScheduleBudgetDayPosition } from "../../../../models"
import AccountStore from "../../../../stores/AccountStore"
import AppStateStore from "../../../../stores/AppStateStore"
import * as colorHelper from "../../../../helpers/colorHelper"
import * as utils from "../../../../helpers/utils"
import _ from "lodash"

interface IProps {
  readonly: boolean
  masterSchedule: boolean
  hierarchyId: string
  scheduleBudgetDay: IScheduleBudgetDay
  update(scheduleBudgetDay): void
  autoAddMissingShifts(shiftTemplate, count): void
}
interface IState {
  positionList: IPosition[]
  loadingPositions: boolean
  showPositionBudgetDialog: boolean
  positionBudgetItem: IScheduleBudgetDayPosition
}

export default class ScheduleTimeinfoDailyBudget extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      positionList: AccountStore.getCurrentAccount().PositionDefinitions,
      loadingPositions: false,
      showPositionBudgetDialog: false,
      positionBudgetItem: null,
    }
    autobind(this)
  }

  componentDidMount() {
    this.getPositionsFromApi()
  }

  getPositionsFromApi() {
    this.setState({ loadingPositions: true }, () =>
      api.getPositions(null, null, null, null, null).then(res => {
        const positionList = res.data as IPosition[]
        this.setState({
          loadingPositions: false,
          positionList,
        })
      })
    )
  }

  getVarianceColor(variance: number) {
    if (variance == 0) {
      return null
    } else if (variance > 0) {
      return green500
    } else {
      return red500
    }
  }

  getVarianceIcon(variance: number) {
    if (variance == 0) {
      return null
    } else if (variance > 0) {
      return (
        <FontIcon className="fa fa-arrow-up" style={{ fontSize: 12, color: green500 }} />
      )
    } else {
      return (
        <FontIcon className="fa fa-arrow-down" style={{ fontSize: 12, color: red500 }} />
      )
    }
  }

  getBudgetItemLabel(row) {
    if (row && row.Unit) {
      return row.Unit.UnitName + " to " + row.Unit.PositionName
    } else {
      return "unknown unit"
    }
  }

  getAutoCreateBudgetStaffButton(row: IScheduleBudgetDayPosition) {
    return undefined
    return (row.MissingShiftCount > 0 && row.ShiftTemplate) ? <span style={{ fontSize: 12, marginLeft: 15, cursor: "pointer" }} title={"Auto-create " + row.MissingShiftCount + " shifts"} onClick={() => {
      AppStateStore.setConfirmDialogContent({
        content: `Are you sure you want to create ${row.MissingShiftCount} shifts based on the attached shift template '${row.ShiftTemplate.Name}'?`,
        confirm: () => {
          let template = _.cloneDeep(row.ShiftTemplate)
          //alert("need to update the template to match the current day so that the new shifts are placed within the day")
          /*
          template.StartDateTime = this.props.scheduleBudgetDay.Date.toISOString()
          template.EndDateTime = this.props.scheduleBudgetDay.Date.toISOString()
          */
          this.props.autoAddMissingShifts(template, row.MissingShiftCount)
        }
      })

    }}>
      <i className="fa-solid fa-wand-magic-sparkles" />
    </span> : undefined
  }

  getPositionCostCode(basePositionId){
    let position = AccountStore.getCurrentAccount().PositionDefinitions.filter(pos => pos.Id == basePositionId)[0]
  
    if(position){
      return position.CostCenter
    }else{
      return "";
    }
  }

  render() {
    const isSingleBudgetVolumeUnit = scheduleHelper.isSingleBudgetVolumeUnit(this.props.scheduleBudgetDay.BudgetPositions)
    const columnOffset = isSingleBudgetVolumeUnit ? -2 : 0
    return (
      <Paper style={{ marginTop: 10, marginBottom: 20, padding: 10, borderRadius: 10 }}>
        {this.props.masterSchedule &&
          <div style={{ marginBottom: 15 }}>
            <Toggle
              toggled={this.props.scheduleBudgetDay.OverrideBudgetUnitsWithProjected ? true : false}
              onToggle={(e, value) => {
                this.props.scheduleBudgetDay.OverrideBudgetUnitsWithProjected = value
                this.props.update(this.props.scheduleBudgetDay)
              }}
              labelPosition="left"
              label={"Override Staff Plan with Projected Unit Counts"}
              style={{ maxWidth: 375 }}
            />
            <Toggle
              toggled={this.props.scheduleBudgetDay.AutoCreateShiftsBasedOnProjectedUnits ? true : false}
              onToggle={(e, value) => {
                this.props.scheduleBudgetDay.AutoCreateShiftsBasedOnProjectedUnits = value
                this.props.update(this.props.scheduleBudgetDay)
              }}
              labelPosition="left"
              label={"Auto Create Shifts Based on Projected Units"}
              style={{ maxWidth: 375 }}
            />
          </div>
        }
        {isSingleBudgetVolumeUnit &&
          <h3>Census: {scheduleHelper.getSingleBudgetVolumeUnitValue(this.props.scheduleBudgetDay.BudgetPositions)}</h3>
        }
        <b>Staff Plan</b>
        {!this.props.readonly &&
          <i
            className="fa fa-plus-circle"
            style={{ fontSize: 20, cursor: "pointer", marginLeft: 10 }}
            onClick={() => this.setState({ positionBudgetItem: null, showPositionBudgetDialog: true })}
          />
        }
        <div style={{ display: "grid", gridTemplateColumns: "auto auto auto auto auto auto auto auto auto auto auto auto auto min-content" }}>
          {!isSingleBudgetVolumeUnit &&
            <div style={{ gridRow: 1, fontSize: 10, gridColumn: 1 + columnOffset }}>
              Unit
            </div>
          }
          {!isSingleBudgetVolumeUnit &&
            <div style={{ gridRow: 1, fontSize: 10, gridColumn: 2 + columnOffset }}>
              Volume
            </div>
          }
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 3 + columnOffset }}>
            Position
          </div>
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 4 + columnOffset }}>
            Budgeted Staff
          </div>
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 5 + columnOffset }}>
            Filled
          </div>
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 6 + columnOffset }}>
            Variance
          </div>
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 7 + columnOffset }}>
            Fill Rate
          </div>
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 8 + columnOffset }}>
            Overtime
          </div>   
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 9 + columnOffset }}>
            Core
          </div>
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 10 + columnOffset }}>
            Float
          </div>
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 11 + columnOffset }}>
            Per Diem
          </div>
          <div style={{ gridRow: 1, fontSize: 10, gridColumn: 12 + columnOffset }}>
            Agency
          </div>                                                      
          {!isSingleBudgetVolumeUnit && this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
            <div key={index} style={{
              gridColumn: 1 + columnOffset,
              gridRow: index + 2,
              color: colorHelper.getBudgetUnitColor(row) + "ff",
              backgroundColor: scheduleHelper.getTransparentBackgroundColor(colorHelper.getBudgetUnitColor(row)),
              borderTopLeftRadius: 5,
              borderBottomLeftRadius: 5,
              paddingLeft: 5,
              cursor: "pointer"
            }}
              onClick={() => {
                this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
              }}
            >
              {row.Unit && row.Unit.UnitName}
            </div>
          )}
          {!isSingleBudgetVolumeUnit && this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
            <div key={index}
              style={{
                gridColumn: 2 + columnOffset,
                gridRow: index + 2,
                color: colorHelper.getBudgetUnitColor(row) + "ff",
                backgroundColor: scheduleHelper.getTransparentBackgroundColor(colorHelper.getBudgetUnitColor(row)),
                cursor: "pointer"
              }}
              onClick={() => {
                this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
              }}
            >
              {row.DemandUnits}
            </div>
          )}
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
            <div key={index} style={{
              gridColumn: 3 + columnOffset,
              gridRow: index + 2,
              color: colorHelper.getBudgetUnitColor(row) + "ff",
              backgroundColor: scheduleHelper.getTransparentBackgroundColor(colorHelper.getBudgetUnitColor(row)),
              borderTopLeftRadius: 5,
              borderBottomLeftRadius: 5,
              cursor: "pointer"
            }}
              onClick={() => {
                this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
              }}
            >
              {row.Unit && <span>{row.Unit.PositionName}</span>}
            </div>
          )}
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
            <div key={index} style={{
              gridColumn: 4 + columnOffset,
              gridRow: index + 2, color: colorHelper.getBudgetUnitColor(row) + "ff", backgroundColor: scheduleHelper.getTransparentBackgroundColor(colorHelper.getBudgetUnitColor(row)), cursor: "pointer"
            }}
              onClick={() => {
                this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
              }}
            >
              {row.BudgetedNumber} {this.getAutoCreateBudgetStaffButton(row)}
            </div>
          )}
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
            <div key={index} style={{
              gridColumn: 5 + columnOffset,
              gridRow: index + 2, color: colorHelper.getBudgetUnitColor(row) + "ff",
              background: scheduleHelper.getTransparentBackgroundColorFade(colorHelper.getBudgetUnitColor(row), "#ffffff"),
              cursor: "pointer"
            }}
              onClick={() => {
                this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
              }}
            >
              {row.FilledShifts}
            </div>
          )}
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) => {
            return (
              <div key={index} style={{
                gridColumn: 6 + columnOffset,
                gridRow: index + 2, color: this.getVarianceColor(row.Variance), paddingLeft: 10, cursor: "pointer"
              }}
                onClick={() => {
                  this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
                }}
              >
                {row.Variance > 0 && "+"}{row.Variance} {this.getVarianceIcon(row.Variance)}
              </div>
            )
          })}
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) => {
            return (
              <div key={index} style={{
                gridColumn: 7 + columnOffset,
                gridRow: index + 2, paddingLeft: 10, cursor: "pointer"
              }}
                onClick={() => {
                  this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
                }}
              >
                {Math.round(row.FillRateInfo.FillRate * 100) + "%"}
              </div>
            )
          })}
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) => {
            return (
              <div key={index} style={{
                gridColumn: 8 + columnOffset,
                gridRow: index + 2, paddingLeft: 10, cursor: "pointer"
              }}
                onClick={() => {
                  this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
                }}
              >
                {Math.round(row.OvertimeInfo.OvertimePercentageOfWhole * 100) + "%"} {Math.round(row.OvertimeInfo.OvertimeTotalHours)} <span style={{fontSize: 10}}>hrs</span>
              </div>
            )
          })}   
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) => {
            return (
              <div key={index} style={{
                gridColumn: 9 + columnOffset,
                gridRow: index + 2, paddingLeft: 10, cursor: "pointer"
              }}
                onClick={() => {
                  this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
                }}
              >
                {Math.round(row.WorkTypeInfo.Core * 100) + "%"}
              </div>
            )
          })}  
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) => {
            return (
              <div key={index} style={{
                gridColumn: 10 + columnOffset,
                gridRow: index + 2, paddingLeft: 10, cursor: "pointer"
              }}
                onClick={() => {
                  this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
                }}
              >
                {Math.round(row.WorkTypeInfo.Float * 100) + "%"}
              </div>
            )
          })}  
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) => {
            return (
              <div key={index} style={{
                gridColumn: 11 + columnOffset,
                gridRow: index + 2, paddingLeft: 10, cursor: "pointer"
              }}
                onClick={() => {
                  this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
                }}
              >
                {Math.round(row.WorkTypeInfo.PerDiem * 100) + "%"}
              </div>
            )
          })}  
          {this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) => {
            return (
              <div key={index} style={{
                gridColumn: 12 + columnOffset,
                gridRow: index + 2, paddingLeft: 10, cursor: "pointer"
              }}
                onClick={() => {
                  this.setState({ positionBudgetItem: row, showPositionBudgetDialog: true })
                }}
              >
                {Math.round(row.WorkTypeInfo.Agency * 100) + "%"}
              </div>
            )
          })}                                                                  
          {!this.props.readonly && this.props.scheduleBudgetDay && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) => {
            return (
              <div key={index} style={{ gridColumn: 13 + columnOffset, gridRow: index + 2, paddingLeft: 10, }}>
                <i
                  className="fa fa-circle-x"
                  style={{ fontSize: 14, cursor: "pointer" }}
                  onClick={() => {
                    AppStateStore.setConfirmDialogContent({
                      content: "Are you sure you want to remove this staff plan item?",
                      confirm: () => {
                        const indexOf = this.props.scheduleBudgetDay.BudgetPositions.indexOf(row)
                        this.props.scheduleBudgetDay.BudgetPositions.splice(indexOf, 1)
                        this.props.update(this.props.scheduleBudgetDay)
                        this.setState({ showPositionBudgetDialog: false })
                      }
                    })
                  }}
                />
              </div>
            )
          })}
        </div>
        {this.state.showPositionBudgetDialog &&
          <ScheduleTimeinfoAddBudgetDialog
            positions={this.state.positionList}
            handleClose={() => this.setState({ showPositionBudgetDialog: false })}
            positionBudgetItem={this.state.positionBudgetItem}
            handleAdd={(unit: IBudgetUnitItem, demandUnits, budgetedNumber, shiftTemplate: IScheduleShift) => {
              if (!this.props.scheduleBudgetDay.BudgetPositions) {
                this.props.scheduleBudgetDay.BudgetPositions = []
              }

              this.props.scheduleBudgetDay.BudgetPositions.push({
                Id: utils.guid(),
                Unit: unit,
                BudgetedNumber: budgetedNumber,
                DemandUnits: demandUnits,
                DemandUnitName: "Unit",
                ShiftTemplate: shiftTemplate
              } as IScheduleBudgetDayPosition)

              this.props.update(this.props.scheduleBudgetDay)
              this.setState({ showPositionBudgetDialog: false })
            }}
            handleEdit={(id: string, unit: IBudgetUnitItem, demandUnits, budgetedNumber, shiftTemplate: IScheduleShift) => {
              if (!this.props.scheduleBudgetDay.BudgetPositions) {
                this.props.scheduleBudgetDay.BudgetPositions = []
              }
              const index = this.props.scheduleBudgetDay.BudgetPositions.findIndex((item) => item.Id == id)
              if (index > -1) {
                this.props.scheduleBudgetDay.BudgetPositions[index].Unit = unit
                this.props.scheduleBudgetDay.BudgetPositions[index].DemandUnits = demandUnits
                this.props.scheduleBudgetDay.BudgetPositions[index].BudgetedNumber = budgetedNumber
                this.props.scheduleBudgetDay.BudgetPositions[index].ShiftTemplate = shiftTemplate
                this.props.update(this.props.scheduleBudgetDay)
                this.setState({ showPositionBudgetDialog: false })
              }
            }}
            hierarchyId={this.props.hierarchyId}
          />
        }
      </Paper>
    )
  }
}